import { ReactComponent as CopyIcon } from '../../../assets/icons/copy.svg';
import { ReactComponent as DeleteFillIcon } from '../../../assets/icons/delete-new-icon.svg';
import { ReactComponent as ArchiveIcon } from '../../../assets/icons/archive.svg';
import {
  isEmpty,
  forbiddenCharacters,
  validateLength,
} from '../../../utility/validation';

export const getAnswerFields = isVertical => {
  return {
    required: true,
    validators: [
      { type: 'isEmpty', validator: isEmpty },
      {
        type: 'maxAnswerEntryLength',
        validator: value => validateLength(value, 0, 2000),
      },
      ...(isVertical
        ? []
        : [{ type: 'forbiddenCharacters', validator: forbiddenCharacters }]),
    ],
  };
};

export const getQuestionActionItems = (
  labels,
  item,
  onDuplicate,
  onDelete,
  onArchive,
  hasErrors
) => [
  ...(!hasErrors
    ? [
        {
          type: 'duplicate',
          label: labels.duplicateLabel,
          action: () => onDuplicate(item),
          shouldItemRender: () => true,
          icon: CopyIcon,
        },
      ]
    : []),
  ...(!hasErrors
    ? [
        {
          type: 'archive',
          label: labels.archiveLabel,
          action: () => onArchive(item),
          shouldItemRender: () => true,
          icon: ArchiveIcon,
        },
      ]
    : []),
  ...(!item.is_used_in_survey
    ? [
        {
          type: 'delete',
          label: labels.deleteLabel,
          action: () => onDelete(item),
          shouldItemRender: () => true,
          icon: DeleteFillIcon,
        },
      ]
    : []),
];

export const QUESTION_TITLE_ERROR = 'error_question_title';
export const ANSWER_TITLE_ERROR = 'error_answer_title';
export const TEXT = 'text';
export const BOX_SIZE_BREAKPOINT = {
  THRESHOLD_FOR_MEDIUM: 6,
  THRESHOLD_FOR_LARGE: 10,
};
export const NEUTRAL_ANSWER = 'Neutral answer';
export const NEUTRAL_ANSWER_WEIGHT = -1;
export const N_A = 'N/A';
export const WARNING_BREAKPOINT_ANSWERS = 10;
export const WARNING_BREAKPOINTS_CHARACTERS = {
  SMALL: 2,
  MEDIUM: 5,
};
export const DELAY = 600;
